var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.68338 7.45583C1.77978 5.97175 2.97296 4.80867 4.45835 4.73508C6.60929 4.62852 9.6836 4.5 12 4.5C14.3164 4.5 17.3907 4.62852 19.5417 4.73508C21.027 4.80867 22.2202 5.97175 22.3166 7.45583C22.409 8.8777 22.5 10.6272 22.5 12C22.5 13.3728 22.409 15.1223 22.3166 16.5442C22.2202 18.0283 21.027 19.1913 19.5417 19.2649C17.3907 19.3715 14.3164 19.5 12 19.5C9.6836 19.5 6.60929 19.3715 4.45835 19.2649C2.97296 19.1913 1.77978 18.0283 1.68338 16.5442C1.59102 15.1223 1.5 13.3728 1.5 12C1.5 10.6272 1.59102 8.87769 1.68338 7.45583Z","fill":"#C9C9CD","key":0}),React.createElement("path",{"d":"M9.75 9V15L15.75 12L9.75 9Z","fill":"#3B3B43","key":1})]);
}

Youtube.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
